//@ts-check
export const UPLOAD_TYPE = [
  {
    label: 'NRIC / Work Pass / Passport',
    value: 'NRIC_OR_PASSPORT',
    key: 'nricPassport',
    // require: ['ON_BOARDING', 'TRANSFER_STAFF', 'OFF_BOARDING'],
    require: [],
  },
  {
    label: 'Acceptance of Resignation Letter',
    value: 'ACCEPTANCE_OF_RESIGNATION_LETTER',
    key: 'acceptanceOfResignationLetter',
    // require: ['ON_BOARDING', 'TRANSFER_STAFF', 'OFF_BOARDING'],
    require: [],
  },
  {
    label: 'Deed of Confidentiality',
    value: 'DEED_OF_CONFIDENTIALITY',
    key: 'deedOfConfidentiality',
    // require: ['ON_BOARDING', 'TRANSFER_STAFF', 'OFF_BOARDING'],
    require: [],
  },
  {
    label: 'Employment Agreement',
    value: 'EMPLOYMENT_AGREEMENT',
    key: 'employmentAgreement',
    // require: ['ON_BOARDING', 'TRANSFER_STAFF'],
    require: [],
  },
  {
    label: 'ECDA Health Check Up',
    value: 'ECDA_HEALTH_CHECK_UP',
    key: 'ecdaHealthCheckUp',
    // require: ['ON_BOARDING', 'TRANSFER_STAFF'],
    require: [],
  },
  {
    label: 'ECDA Declaration Form',
    value: 'ECDA_DECLARATION_FORM',
    key: 'ecdaDeclarationForm',
    // require: ['ON_BOARDING', 'TRANSFER_STAFF'],
    require: [],
  },
  {
    label: 'Letter of Notification',
    value: 'LETTER_OF_NOTIFICATION',
    key: 'notificationLetter',
    require: [],
  },
  {
    label: 'Child 1st Aid Certification',
    value: 'CHILD_1ST_AID_CERTIFICATION',
    key: 'childAidCertification',
    require: [],
  },
  {
    label: 'Sponsorship Agreement',
    value: 'SPONSORSHIP_AGREEMENT',
    key: 'sponsorShipAgreement',
    require: [],
  },
  {
    label: 'Service Agreement',
    value: 'SERVICE_AGREEMENT',
    key: 'serviceAgreement',
    require: [],
  },
  {
    label: 'MSF Declaration Form',
    value: 'MSF_DECLARATION_FORM',
    key: 'msfDeclarationForm',
    require: [],
  },
  {
    label: 'MSF Health Check Up',
    value: 'MSF_HEALTH_CHECK_UP',
    key: 'msfHealthCheckUp',
    require: [],
  },
];

export const REQUEST_TYPE = [
  {
    label: 'Onboarding - New Staff',
    value: 'ON_BOARDING',
  },
  {
    label: 'Onboarding - Transfer Staff',
    // value: 'TRANSFER_STAFF',
    value: '',
  },
  {
    label: 'Offboarding',
    value: 'OFF_BOARDING',
  },
];

export const COURSE_LANGUAGE = [
  {
    label: 'English',
    value: 'ENGLISH',
  },
  {
    label: 'Chinese',
    value: 'CHINESE',
  },
];

export const EXIT_INTERVIEW = [
  { label: 'Yes', value: 'YES' },
  { label: 'No', value: 'NO' },
];

export const STAFF_REQUEST_STATUS = [
  {
    label: 'Notified',
    value: 'NOTIFIED',
  },
  {
    label: 'Rejected',
    value: 'REJECTED',
  },
  {
    label: 'Re Submitted',
    value: 'RE_SUBMITTED',
  },
  {
    label: 'Account Setup Pending',
    value: 'ACCOUNT_SETUP_PENDING',
  },
  {
    label: 'Requester Action Pending',
    value: 'PENDING_FOR_ACCEPTANCE',
  },

  {
    label: 'Accepted',
    value: 'APPROVED',
  },

  {
    label: 'Account Created',
    value: 'COMPLETED',
  },
  {
    label: 'Process Stopped',
    value: 'STOP_PROCESS',
  },
  // {
  //   label: 'Inprogress',
  //   value: 'WAITING',
  // },
];
export const STAFF_REQUESTER_TYPES = [
  {
    label: 'On Boarding',
    value: 'ON_BOARDING',
  },
  {
    label: 'Transfer Staff',
    // value: 'TRANSFER_STAFF',
    value: '',
  },
  {
    label: 'Off Boarding',
    value: 'OFF_BOARDING',
  },
];

export const FORM_CONFIG = {
  [REQUEST_TYPE[0].value]: [
    'courseCentre',
    'requestType',
    'staffFirstName',
    'staffLastName',
    'designation',
    'staffRole',
    'staffPrevious',
    'previousEntity',
    'PreviousEmailStaff',
    'lastWorked',
    'language',
    'comments',
    'startDate',
    'notificationLetter',
    'childAidCertification',
    'sponsorShipAgreement',
    'employmentAgreement',
    'serviceAgreement',
    'nricPassport',
    'ecdaDeclarationForm',
    'ecdaHealthCheckUp',
    'msfDeclarationForm',
    'msfHealthCheckUp',
  ],
  // [REQUEST_TYPE[1].value]: [
  //   'courseCentre',
  //   'requestType',
  //   'transferEmail',
  //   'staffFirstName',
  //   'staffLastName',
  //   'previousEntity',
  //   'staffPrevious',
  //   'designation',
  //   'transferCourseCentre',
  //   'language',
  //   'startDate',
  //   'comments',
  //   'notificationLetter',
  //   'childAidCertification',
  //   'sponsorShipAgreement',
  //   'employmentAgreement',
  //   'nricPassport',
  //   'ecdaDeclarationForm',
  //   'ecdaHealthCheckUp',
  // ],
  [REQUEST_TYPE[2].value]: [
    'courseCentre',
    'requestType',
    'staffFirstName',
    'staffLastName',
    'email',
    'designation',
    'startDate',
    'lastDate',
    'staffContactNumber',
    'residenceAddress',
    'interviewSchedule',
    'comments',
    'passportNo',
    'acceptanceOfResignationLetter',
    'deedOfConfidentiality',
  ],
};

export const STAFF_JOURNEY_TYPE = {
  USERCREATION: 'USER_CREATION',
  LEARNINGPATHASSIGN: 'LEARNING_PATH_CREATION',
  APPROVAL: 'APPROVAL',
  REJECTED: 'REJECTED',
  REASON: 'REASON',
  REQUEST: 'REQUEST',
  EMAIL: 'EMAIL',
  USER_DEACTIVE: 'USER_DEACTIVE',
  ACCOUNT_SETUP: 'ACCOUNT_SETUP',
  REASON_UPDATE: 'REASON_UPDATE',
  USER_UPDATED: 'USER_UPDATED',
  COMPLETED: 'COMPLETED',
  PENDING_FOR_ACCEPTANCE: 'PENDING_FOR_ACCEPTANCE',
};

export const STAFF_JOURNEY_STATUS = {
  COMPLETED: 'COMPLETED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  SUBMITTED: 'SUBMITTED',
  ASSIGNED: 'ASSIGNED',
  RE_SUBMITTED: 'RE_SUBMITTED',
  ACCOUNT_SETUP_PENDING: 'ACCOUNT_SETUP_PENDING',
  PENDING_FOR_ACCEPTANCE: 'PENDING_FOR_ACCEPTANCE',
  STAFF_REQUEST_REJECTION: 'Staff Request Rejected',
  STAFF_REQUEST_APPROVED: 'Staff Request Approved',
  STAFF_REQUEST_NOTIFIED: 'Staff Request Notified',
  STAFF_REQUEST_PROCESSED: 'Staff Request Processed',
  STAFF_REQUEST_RE_SUBMITTED: 'Staff Request Resubmitted',
  STOP_PROCESS: 'STOP_PROCESS',
};
export const statusMappings = {
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_NOTIFIED]: 'NOTIFIED',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_APPROVED]: 'APPROVED',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_REJECTION]: 'REJECTED',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_PROCESSED]: 'PROCESSED',
  [STAFF_JOURNEY_STATUS.SUBMITTED]: 'SUBMITTED',
  [STAFF_JOURNEY_STATUS.ASSIGNED]: 'ASSIGNED',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_RE_SUBMITTED]: 'RE_SUBMITTED',
};
export const STAFF_GRID_HOVER_MAP = {
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_NOTIFIED]: 'Notified',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_APPROVED]: 'Accepted',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_REJECTION]: 'Rejected',
  [STAFF_JOURNEY_STATUS.STAFF_REQUEST_PROCESSED]: 'Processed',
  [STAFF_JOURNEY_STATUS.SUBMITTED]: 'Submitted',
  [STAFF_JOURNEY_STATUS.ASSIGNED]: 'Assigned',
  [STAFF_JOURNEY_STATUS.COMPLETED]: 'Account Created',
  [STAFF_JOURNEY_STATUS.RE_SUBMITTED]: 'Re-submitted',
  [STAFF_JOURNEY_STATUS.ACCOUNT_SETUP_PENDING]: 'Account Setup Pending',
  [STAFF_JOURNEY_STATUS.PENDING_FOR_ACCEPTANCE]: 'Requester Action Pending',
  [STAFF_JOURNEY_STATUS.STOP_PROCESS]: 'Process Stopped',
};
export const STAFF_REQUEST_TYPES = [
  'REQUEST',
  'APPROVAL',
  'EMAIL',
  'REASON',
  'USER_CREATION',
  'LEARNING_PATH_CREATION',
  'LMS_ACCOUNT_CREATED',
  'OUTLOOK_ACCOUNT_CREATED',
  'REASON_UPDATE',
  'ACCOUNT_SETUP',
  'USER_DEACTIVE',
];

export const STAFF_REQUEST_PERMISSION = /**@type {const} */ ([
  {
    method: 'POST',
    route: 'stripe/create-payment',
    name: 'stripPayment',
    mapKey: 'TOP_UP',
  },

  {
    method: 'POST',
    route: 'points/',
    name: 'pointsCreate',
    mapKey: 'ADD_CREDIT',
  },
]);

export const STAFF_TEMP = `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html data-editor-version="2" class="sg-campaigns" xmlns="http://www.w3.org/1999/xhtml">
<head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1">
    <meta http-equiv="X-UA-Compatible" content="IE=Edge">

</head>
<body>
  
</body>
</html>
`;

export const REQUEST_TYPE_CONFIG = {
  ON_BOARDING: ['requestType', 'courseCentre', 'designation'],
  TRANSFER_STAFF: [
    'requestType',
    'courseCentre',
    'transferEmail',
    'transferCourseCentre',
    'designation',
  ],
  OFF_BOARDING: ['requestType', 'courseCentre', 'email', 'designation'],
};

export const FORM_SETUP = {
  ON_BOARDING: {
    requestType: {
      show: true,
      label: 'Request Type',
      keyName: 'requestType',
      require: true,
      disable: true,
    },
    courseCentre: {
      show: true,
      label: 'Centre',
      keyName: 'courseCentre',
      require: true,
      disable: true,
    },
    designation: {
      show: true,
      label: 'Staff Type',
      keyName: 'designation',
      require: true,
      disable: true,
    },
    staffRole: {
      show: true,
      label: 'Designation',
      keyName: 'staffRole',
      require: true,
      disable: false,
    },
    staffPrevious: {
      show: true,
      label: 'Was this Staff Previously with MindChamps?',
      keyName: 'staffPrevious',
      require: false,
    },
    previousEntity: {
      show: true,
      label: 'Previous Entity Name and Centre Location',
      keyName: 'previousEntity',
      require: false,
    },
    PreviousEmailStaff: {
      show: true,
      label: 'Previous Email of staff',
      keyName: 'PreviousEmailStaff',
      require: false,
    },
    lastWorked: {
      show: true,
      label: 'When did this staff left MindChamps previously? ',
      keyName: 'lastWorked',
      require: false,
    },
    staffFirstName: {
      show: true,
      label: 'First Name',
      keyName: 'staffFirstName',
      require: true,
    },
    staffLastName: {
      show: true,
      label: 'Last Name',
      keyName: 'staffLastName',
      require: true,
    },
    language: {
      show: true,
      label: 'Staff GE Induction Programme Course Language',
      keyName: 'language',
      require: true,
    },
    startDate: {
      show: true,
      label: 'Start Date',
      keyName: 'startDate',
      require: true,
    },
    notificationLetter: {
      show: true,
      label: 'Notification Letter',
      keyName: 'notificationLetter',
      require: true,
    },
    childAidCertification: {
      show: true,
      label: 'Child 1st Aid Certification',
      keyName: 'childAidCertification',
      require: true,
    },
    sponsorShipAgreement: {
      show: true,
      label: 'Sponsorship Agreement',
      keyName: 'sponsorShipAgreement',
      require: false,
    },
    employmentAgreement: {
      show: true,
      label: 'Employment Agreement',
      keyName: 'employmentAgreement',
      require: false,
    },
    serviceAgreement: {
      show: true,
      label: 'Service Agreement',
      keyName: 'serviceAgreement',
      require: false,
    },
    nricPassport: {
      show: true,
      label: 'NRIC / Work Pass / Passport',
      keyName: 'nricPassport',
      require: false,
    },
    ecdaDeclarationForm: {
      show: true,
      label: 'ECDA Declaration Form',
      keyName: 'ecdaDeclarationForm',
      require: false,
    },
    ecdaHealthCheckUp: {
      show: true,
      label: 'ECDA Health Check Up',
      keyName: 'ecdaHealthCheckUp',
      require: false,
    },
    msfDeclarationForm: {
      show: true,
      label: 'MSF Declaration Form',
      keyName: 'msfDeclarationForm',
      require: false,
    },
    msfHealthCheckUp: {
      show: false,
      label: 'MSF Health Check Up',
      keyName: 'msfHealthCheckUp',
      require: false,
    },
    comments: {
      show: true,
      label: 'Comments',
      keyName: 'comments',
      require: false,
    },
  },

  // TRANSFER_STAFF: {
  //   requestType: {
  //     show: true,
  //     label: 'Request Type',
  //     keyName: 'requestType',
  //     require: true,
  //     disable: true,
  //   },
  //   courseCentre: {
  //     show: true,
  //     label: 'Centre',
  //     keyName: 'courseCentre',
  //     require: true,
  //     disable: true,
  //   },
  //   transferEmail: {
  //     show: true,
  //     label: 'Transfer Email',
  //     keyName: 'transferEmail',
  //     require: true,
  //     disable: true,
  //   },

  //   transferCourseCentre: {
  //     show: true,
  //     label: 'Transfer Centre',
  //     keyName: 'transferCourseCentre',
  //     require: false,
  //     disable: true,
  //   },

  //   designation: {
  //     show: true,
  //     label: 'Staff Type',
  //     keyName: 'designation',
  //     require: true,
  //     disable: true,
  //   },

  //   staffFirstName: {
  //     show: true,
  //     label: 'First Name',
  //     keyName: 'staffFirstName',
  //     require: true,
  //   },
  //   staffLastName: {
  //     show: true,
  //     label: 'Last Name',
  //     keyName: 'staffLastName',
  //     require: true,
  //   },
  //   previousEntity: {
  //     show: true,
  //     label: 'Previous Entity',
  //     keyName: 'previousEntity',
  //     require: false,
  //   },
  //   staffPrevious: {
  //     show: true,
  //     label: 'Was this Staff Previously with MindChamps?',
  //     keyName: 'staffPrevious',
  //     require: false,
  //   },

  //   language: {
  //     show: true,
  //     label: 'Staff GE Induction Programme Course language',
  //     keyName: 'language',
  //     require: true,
  //   },
  //   startDate: {
  //     show: true,
  //     label: 'Start Date',
  //     keyName: 'startDate',
  //     require: true,
  //   },
  //   comments: {
  //     show: true,
  //     label: 'Comments',
  //     keyName: 'comments',
  //     require: false,
  //   },
  //   notificationLetter: {
  //     show: true,
  //     label: 'Notification Letter',
  //     keyName: 'notificationLetter',
  //     require: true,
  //   },
  //   childAidCertification: {
  //     show: true,
  //     label: 'Child 1st Aid Certification',
  //     keyName: 'childAidCertification',
  //     require: false,
  //   },
  //   sponsorShipAgreement: {
  //     show: true,
  //     label: 'Sponsorship Agreement',
  //     keyName: 'sponsorShipAgreement',
  //     require: false,
  //   },
  //   employmentAgreement: {
  //     show: true,
  //     label: 'Employment Agreement',
  //     keyName: 'employmentAgreement',
  //     require: false,
  //   },
  //   nricPassport: {
  //     show: true,
  //     label: 'NRIC or Passport',
  //     keyName: 'nricPassport',
  //     require: false,
  //   },
  //   ecdaDeclarationForm: {
  //     show: true,
  //     label: 'ECDA Declaration Form',
  //     keyName: 'ecdaDeclarationForm',
  //     require: false,
  //   },
  //   ecdaHealthCheckUp: {
  //     show: true,
  //     label: 'ECDA Health Check Up',
  //     keyName: 'ecdaHealthCheckUp',
  //     require: false,
  //   },
  // },

  OFF_BOARDING: {
    requestType: {
      show: true,
      label: 'Request Type',
      keyName: 'requestType',
      require: true,
      disable: true,
    },
    courseCentre: {
      show: true,
      label: 'Centre',
      keyName: 'courseCentre',
      require: true,
      disable: true,
    },
    email: {
      show: true,
      label: 'Email',
      keyName: 'email',
      require: true,
      disable: true,
    },
    designation: {
      show: true,
      label: 'Staff Type',
      keyName: 'designation',
      require: true,
      disable: true,
    },
    staffFirstName: {
      show: true,
      label: 'First Name',
      keyName: 'staffFirstName',
      require: true,
    },
    staffLastName: {
      show: true,
      label: 'Last Name',
      keyName: 'staffLastName',
      require: true,
    },
    passportNo: {
      show: true,
      label: 'NRIC/FIN/Passport No',
      keyName: 'passportNo',
      require: true,
    },
    startDate: {
      show: true,
      label: 'Start Date',
      keyName: 'startDate',
      require: true,
    },
    lastDate: {
      show: true,
      label: 'Last Working Date',
      keyName: 'lastDate',
      require: true,
    },
    staffContactNumber: {
      show: true,
      label: 'Contact Number',
      keyName: 'staffContactNumber',
      require: true,
    },
    residenceAddress: {
      show: true,
      label: 'Residential Address',
      keyName: 'residenceAddress',
      require: true,
    },
    interviewSchedule: {
      show: true,
      label: 'Have you scheduled the exit interview with HR?',
      keyName: 'interviewSchedule',
      require: true,
    },
    acceptanceOfResignationLetter: {
      show: true,
      label: 'Acceptance of Resignation Letter',
      keyName: 'acceptanceOfResignationLetter',
      require: true,
    },
    deedOfConfidentiality: {
      show: true,
      label: 'Deed of Confidentiality',
      keyName: 'deedOfConfidentiality',
      require: true,
    },
    comments: {
      show: true,
      label: 'Comments',
      keyName: 'comments',
      require: false,
    },
  },
};

export const MINDCHAMPS_EMAIL_PATTERN = {
  emailPattern: {
    value: /^[a-zA-Z0-9._%+-]+@mindchamps/,
    message: 'Email must contain @mindchamps.org',
  },
};
export const PASSWORD_PATTERN = {
  BASIC: {
    value: 8,
    message: 'Password must be at least 8 characters long',
  },
  SPECIAL: {
    value: /[@$!%*?&]/,
    message: 'Password must include at least one special character (@$!%*?&)',
  },
  NUMBER: {
    value: /\d/,
    message: 'Password must include at least one number',
  },
  UPPERCASE: {
    value: /[A-Z]/,
    message: 'Password must include at least one uppercase letter',
  },
};
